import { VendorCacheModel } from "./VendorCache.model";

export class VendorCache extends VendorCacheModel {
    // Add custom methods here
}
